/* eslint-disable */
void (function() {
  var doc = document;
  var docEle = doc.documentElement;

  function setRootFontSize(width) {
    width = width || docEle.getBoundingClientRect().width;
    docEle.style.fontSize = (width / 375) * 16 + "px";
  }

  if (/Mobi/.test(navigator.userAgent)) {
    void (function() {
      var timer;

      setRootFontSize();
      window.addEventListener(
        "resize",
        function() {
          clearTimeout(timer);
          timer = setTimeout(setRootFontSize, 300);
        },
        false
      );
    })();
  } else {
    void (function() {
      var pcWidth = 750;
      var style = doc.createElement("style");

      style.innerHTML =
        "body{width:" + pcWidth + "px!important;margin:0 auto!important}";
      doc.getElementsByTagName("head")[0].appendChild(style);
      setRootFontSize(pcWidth);
    })();
  }
})();
